<template>
	<div>
		<!-- CABEÇALHO -->
		<div style="margin-left: 15px; margin-right: -15px" :class="{'no-print': print}">
			<table class="table table-bordered table-condensed table-siga">
				<tbody>
					<tr>
						<td style="width: 25%; vertical-align: middle" class="text-center">
							<img :src="_img1" :style="{width: ((_idCliente == 38)?width-100:width)  + 'px'}" />
						</td>
						<td style="width: 50%;vertical-align: middle;" class="text-center">
							<p>
								<strong>{{ _titulo }}</strong>
							</p>
							<p>
								<strong>{{ subtitulo || _subtitulo }}</strong>
							</p>
							<p v-show="_idCliente == 10">
								<strong>Centro Tático Aéreo <br />Departamento de Operações</strong>
							</p>
						</td>
						<td style="width: 25%; vertical-align: middle" class="text-center">
							<img v-show="_idCliente != 10" style="width: 70px" src="../../../assets/img/logo.png" />
							<img v-show="_idCliente == 10" :src="_img2" :style="{height: width2 + 'px'}" />
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		print: {
			type: Boolean,
			default: false
		},

		widthimg: {
			type: String,
			default: ''
		},

		widthimg2: {
			type: String,
			// default: '80'
			default: ''
		},

		top: {
			type: String,
			default: ''
		},

		subtitulo: {
			type: String,
			default: null
		},
	},

	data() {
		return {
			width: 70,
			width2: 80,
			margintop: 5
		}
	},

	beforeMount() {
		if (this.widthimg != '') {
			this.width = this.widthimg
		}
		if (this.widthimg2 != '') {
			this.width2 = this.widthimg2
		}
	}
}
</script>